import LoadingSkeleton from 'react-loading-skeleton'
import styled from 'styled-components'

export const ColorSelectorWrapper = styled.div<{ center: boolean }>`
  display: flex;
  flex-wrap: wrap;
  justify-content: ${({ center }) => (center ? 'center' : 'flex-start')};
  gap: 0.5rem;
  cursor: auto;

  > span {
    line-height: 0;
    font-size: 0;
  }
`

export const Skeleton = styled(LoadingSkeleton)`
  margin: 0.25rem 0.5rem;
  line-height: 0;
  font-size: 0;
`
